import {Component, Input, OnInit, Optional} from '@angular/core';
import {TableHeaderService} from '../../services/table-header.service';
import {LoaderService} from '../../services/loader.service';
import {PurchaseService} from '../../services/purchase.service';
import {ITableHeader} from '../../../interfaces/table-header';
import {ModalReceiptDetailsComponent} from '../../components/modals/modal-receipt-details/modal-receipt-details.component';
import {BsModalService} from 'ngx-bootstrap/modal';
import {TableEntityExtension} from '../../extensions/table-entity-extension/table-entity.extension';
import {ModalBonusComponent} from '../../components/modals/modal-bonus/modal-bonus.component';
import {ProductType} from '../../utils/product';
import {TableEntityExtensionService} from '../../extensions/table-entity-extension/table-entity-extension.service';
import {ActivatedRoute} from '@angular/router';
import {CardService} from '../../components/card/card.service';
import {finalize} from 'rxjs/operators';
import {ModalReceiptsListComponent} from '../../components/modals/modal-receipts-list/modal-receipts-list.component';
import {ModalConfirmComponent} from '../../components/modals/modal-confirm/modal-confirm.component';

@Component({
  selector: 'table-purchase',
  templateUrl: './table-purchase.component.html',
  providers: [LoaderService]
})
export class TablePurchaseComponent extends TableEntityExtension implements OnInit {

  @Input('store') set store$(value: any) {
    if (value) {
      // this.query.filters.parentStore = value;
      this.handleHeaders(value, 'parentStore', 'store');
    }

  }

  ProductType = ProductType;

  headers: ITableHeader[];

  query: any = {
    filters: {},
    order: {
      id: 'DESC'
    },
    relations: ['project', 'storeCollection', 'users', 'receipts', 'parentStore', 'market', 'product', 'action']
  };

  constructor(public loaderService: LoaderService,
              protected route: ActivatedRoute,
              protected modelService: PurchaseService,
              protected tableEntityExtensionService: TableEntityExtensionService,
              @Optional() protected cardService: CardService,
              private tableHeaderService: TableHeaderService,
              private modalService: BsModalService) {
    super(
      modelService,
      cardService,
      loaderService,
      tableEntityExtensionService,
      route
    );
  }

  ngOnInit(): void {
    this.headers = [
      this.tableHeaderService.id(),
      this.tableHeaderService.users({sort: false}),
      this.tableHeaderService.store({filter: {key: 'parentStore'}, sort: {key: 'parentStore'}}),
      this.tableHeaderService.market(),
      this.tableHeaderService.product({
        filter: {
          storeQuery: (this.query.filters.store || this.query.filters.parentStore) ? {
            parentStore: this.query.filters.store || this.query.filters.parentStore
          } : null
        }
      }),
      this.tableHeaderService.expiredAt(),
      this.tableHeaderService.receipt({sort: false, filter: false}),
      this.tableHeaderService.productType(),
      this.tableHeaderService.validated(),
      this.tableHeaderService.checked(),
      this.tableHeaderService.sandBox(),
      this.tableHeaderService.force(),
      this.tableHeaderService.failed(),
      this.tableHeaderService.innerPurchase(),

      this.tableHeaderService.originalTransactionId(),
      this.tableHeaderService.subject({sort: false, filter: false}),
      this.tableHeaderService.updatedAt(),
      this.tableHeaderService.createdAt(),
      this.tableHeaderService.json(),
      // this.tableHeaderService.actions(),
    ];
    this.checkChanges();
  }

  showReceipt(id: any) {
    this.modalService.show(ModalReceiptDetailsComponent, {
      initialState: {id},
    });
  }

  showAllReceipts(item: any) {
    this.modalService.show(ModalReceiptsListComponent, {
      initialState: {items: item.receipts},
    });
  }

  addPurchase() {
    let modalRef = this.modalService.show(ModalBonusComponent, {
      initialState: {
        user: this.query.filters.user
      },
      backdrop: 'static'
    });
    modalRef.content.purchased.subscribe(() => {
      this.getItems();
    });
  }

  getJson(string) {
    try {
      let json = JSON.parse(string);
      delete json.latest_receipt;
      return json
    } catch (err) {
      return string;
    }
  }

  toggleJson(item) {
    (item.show) ? this.hideJson(item) : this.showJson(item);
  }

  showJson(item) {
    item.jsonLoading = true;
    this.modelService.get({id: item.id})
      .pipe(finalize(() => {
        item.jsonLoading = false;
        item.show = true;
      }))
      .subscribe((res: any) => {
          item.lastResponseFromProvider = this.getJson(res.lastResponseFromProvider);
        },
        err => {
          console.log(err);
        }
      );
  }

  confirmFail(item) {
    let dialog = this.modalService.show(ModalConfirmComponent, {
      initialState: {
        id: item.id,
        // name: `${title} ${name}`,
        confirm: () => {
          this.fail(item);
          dialog.hide();
        },
        cancel: () => {

        }
      }
    });
  }

  fail(item) {
    let body = {
      id: item.id,
      validated: false,
      failed: true,
      code: 21004
    };
    this.modelService.update(body)
      .pipe(finalize(() => {
        Object.assign(item, body);
      }))
      .subscribe((res: any) => {
        },
        err => {
          console.log(err);
        }
      );
  }

  hideJson(item) {
    item.show = false;
  }
}
